module.exports = __webpack_public_path__ + "img/djdc-full.2078b0ac.png";